<template>
  <div val-end>
    <div>
      <HomeHeader />
      <DiscordSection />
      <SpecialLeague />
      <CommunityLeague v-show="false" />
      <HistorySection />
    </div>
  </div>
</template>

<script>
import DiscordSection from '@/views/components/end/DiscordSection.vue';
import SpecialLeague from '@/views/components/end/SpecialLeague.vue';
import CommunityLeague from '@/views/components/end/CommunityLeague.vue';
import HistorySection from '@/views/components/end/HistorySection.vue';
import HomeHeader from '@/views/components/gameHome/HomeHeader.vue';
import meta from '@/data/meta';

export default {
  name: 'ValEnd',
  components: { SpecialLeague, DiscordSection, CommunityLeague, HistorySection, HomeHeader },
  metaInfo() {
    return meta[this.$route.params.id][this.$route.name];
  },
};

</script>

<style lang="less">
@import '~@/less/proj.less';

[val-end] {.font-g; .mh-c;
  [discord-section] {
    .contents-wrapper {
      .detail {
        .main {
          > em { .c(#ff4655); }
        }
      }
      .discord {
        > a { .bgc(#ff4655);}
      }
    }
  }
  [history-section] {
    .contents-wrapper {
      .contents-holder {
        .box {
          .detail {
            h3 { .c(#4b38ff);}
          }
        }
      }
    }
  }
}

</style>
